import { Stack } from "@mui/material";
import { useAppContext } from "../../../../shared/contexts/app-context/components/AppContext";
import { ModuleType } from "../../types/ModuleType";
import { ViewSectionType } from "../../types/ViewSectionType";

export function ModuleSelectorItem({
    type,
    caption
}: {
    type: ModuleType,
    caption: string
}) {
    const {
        activeViewSection,
        leftViewSectionModuleType,
        setLeftViewSectionModuleType,
        rightViewSectionModuleType,
        setRightViewSectionModuleType,
    } = useAppContext();

    const getSelectedModuleNameInActiveViewSection = (): ModuleType => {
        switch (activeViewSection) {
            case ViewSectionType.Left:
                return leftViewSectionModuleType;
            case ViewSectionType.Right:
                return rightViewSectionModuleType;

            default:
                throw Error('Unrecognized view section');
        }
    }

    const setModuleTypeToActiveViewSection = (moduleType: ModuleType): void => {
        switch (activeViewSection) {
            case ViewSectionType.Left:
                setLeftViewSectionModuleType(moduleType);
                break;
            case ViewSectionType.Right:
                setRightViewSectionModuleType(moduleType);
                break;

            default:
                throw Error('Unrecognized view section');
        }
    }

    const isActive = type === getSelectedModuleNameInActiveViewSection();

    const handleClick = () => {
        setModuleTypeToActiveViewSection(type);
    }

    return (
        <Stack
            sx={{
                fontWeight: '600',
                fontSize: '13.5px',
                color: isActive
                    ? '#FACC2D'
                    : '#bdbcbc',
                paddingTop: '7px',
                paddingLeft: '7px',
                paddingRight: '7px',
                height: '33px',
                minHeight: '33px',
            }}
            style={{
                cursor: 'pointer'
            }}
            onClick={() => handleClick()}
        >
            {caption}
        </Stack>
    );
}